// src/components/RatingDistribution.jsx - Complete Fixed Version

import React from 'react';

const RatingDistribution = ({ ratingsData, totalReviews }) => {
  // Debug: Log the data to verify
  console.log('📊 [RatingDistribution] Input Data:', {
    ratingsData,
    totalReviews,
  });

  // FIX: Ensure ratingsData is always an array
  const safeRatingsData = Array.isArray(ratingsData) ? ratingsData : [];

  // FIX: Ensure all 5 star levels are present with proper counts
  const completeRatingsData = [5, 4, 3, 2, 1].map(stars => {
    const found = safeRatingsData.find(r => r.stars === stars);
    return {
      stars,
      count: found?.count ?? 0,
    };
  });

  // FIX: Calculate total count from complete data
  const totalCount = completeRatingsData.reduce((sum, r) => sum + r.count, 0);

  console.log('📊 [RatingDistribution] Processed Data:', {
    completeRatingsData,
    totalCount,
    totalReviews,
  });

  // If no reviews, show empty state
  if (totalCount === 0 || totalReviews === 0) {
    return (
      <div className="text-center py-4" style={{ color: 'var(--muted)' }}>
        No reviews yet
      </div>
    );
  }

  // Find the maximum count for scaling
  const maxCount = Math.max(...completeRatingsData.map(r => r.count || 0), 0);
  // Maximum bar width percentage (90% so the bar never goes full)
  const MAX_BAR_WIDTH = 90;

  console.log('📊 [RatingDistribution] Max Count:', maxCount);

  return (
    <div className="space-y-3">
      {completeRatingsData.map(rating => {
        const count = rating.count || 0;
        // Calculate percentage based on max count
        // Scale so the highest bar is MAX_BAR_WIDTH% (90%)
        const percentage =
          maxCount > 0 ? (count / maxCount) * MAX_BAR_WIDTH : 0;

        console.log(
          `⭐ Rating ${rating.stars}: count=${count}, percentage=${percentage}%`,
        );

        return (
          <div key={rating.stars} className="flex items-center gap-3">
            {/* Star Rating Section */}
            <div className="flex items-center gap-1 w-20 flex-shrink-0">
              <span className="text-sm" style={{ color: 'var(--text)' }}>
                {rating.stars}
              </span>
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map(star => (
                  <svg
                    key={star}
                    className={`w-3 h-3 ${star <= rating.stars ? 'fill-current text-yellow-400' : 'text-gray-400'}`}
                    viewBox="0 0 2000 2000"
                    xmlns="http://www.w3.org/2000/svg"
                    fill={star <= rating.stars ? 'currentColor' : 'none'}
                    stroke={star <= rating.stars ? 'none' : 'currentColor'}
                    strokeWidth="100"
                  >
                    <path d="M1940.9,893.45c-13,44.44-40.18,82.71-78.67,110.68l-326.25,237a10.56,10.56,0,0,0-3.83,11.8l124.62,383.52c21.12,65,10.52,133.53-29.07,188-40.08,55.16-104.21,88.09-171.56,88.09-44.05,0-86.71-14.08-123.37-40.72l-326.24-237a10.57,10.57,0,0,0-12.4,0l-326.24,237c-36.66,26.64-79.32,40.72-123.37,40.72-67.36,0-131.49-32.93-171.56-88.08-39.59-54.5-50.19-123-29.07-188l124.62-383.53a10.53,10.53,0,0,0-3.83-11.78l-326.25-237c-38.49-28-65.69-66.24-78.67-110.68a213.4,213.4,0,0,1,73.73-226.91c36.62-28.32,81.12-43.29,128.7-43.29H665.45a10.53,10.53,0,0,0,10-7.29L800.09,232.44c14.7-45.25,42.69-82.95,80.95-109a213.38,213.38,0,0,1,238.58,0c38.26,26.07,66.25,63.77,81,109L1325.18,616a10.53,10.53,0,0,0,10,7.29h403.26c47.58,0,92.08,15,128.7,43.29a213.4,213.4,0,0,1,73.73,226.91Z" />
                  </svg>
                ))}
              </div>
            </div>

            {/* Bar Section */}
            <div
              className="flex-1 h-2.5 rounded-full overflow-hidden"
              style={{ backgroundColor: 'var(--border)' }}
            >
              <div
                className="h-full rounded-full transition-all duration-700 ease-out"
                style={{
                  width: count > 0 ? `${Math.max(percentage, 4)}%` : '0%',
                  backgroundColor: count > 0 ? 'var(--text)' : 'transparent',
                  minWidth: count > 0 ? '8px' : '0',
                }}
              />
            </div>

            {/* Count Section */}
            <div
              className="text-sm font-mono w-12 text-right"
              style={{ color: 'var(--muted)' }}
            >
              {count}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RatingDistribution;
